import { ROUTES } from '@/constants/routes'

export default function trialEnded({ next, router, store }) {
    const { account, getAccountSlug } = store

    if (account && !account.is_active && account.trial_ended) {
        return router.push({ name: ROUTES.verification, params: { account: getAccountSlug } })
    }

    next()
}
